<template>
  <div
    class="desktop-view page"
  >
    <div class="sensata-splash-wrapper">
      <SensataSplash></SensataSplash>

      <el-button
        class="log-out-button delay-entry delay-like-crazy"
        round
        type="danger"
        @click="logOut()"
        v-if="loggedIn"
      >Log out</el-button>
    </div>

    <div class="admin-content-wrapper unselectable delay-entry">
      <p class="random-quotes delay-entry delay-like-crazy">
        {{randomQuote}}
      </p>
      <el-row class="log-in-button-wrapper">
        <el-button
          class="delay-entry delay-like-crazy log-in-button"
          round
          type="danger"
          @click="logIn()"
          v-if="!loggedIn"
        >Log in</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AuthService from 'Core/src/auth/authService'

Vue.use(AuthService)
Vue.prototype.$eventHub = new Vue()

export default {
  name: 'Admin',

  components: {
    SensataSplash: () => import('Components/base/SensataSplash')
  },

  computed: {
    randomQuote () {
      var quotes = [
        'Una pelota y un bate de béisbol cuestan $1.10. Si el bate cuesta un dólar más que la pelota, ¿cuánto cuesta ésta?',
        'Usted está en una carrera y pasa al segundo participante. ¿En qué puesto queda?',
        'El papá de mary tiene cinco hijas: Nana, Nene, Nini, Nono y ?? ¿Cuál es el nombre de la última?',
        'En un lago hay unos nenúfares que crecen se duplican en superficie cada día. Si les toma 48 días llenar el lago, ¿cuántos días les toma llenar la mitad del lago?'
      ]
      return quotes[Math.floor(Math.random() * quotes.length)]
    },
    profiles () {
      return this.$store.state.testResults.profiles
    },
    username () {
      return this.$store.state.user.auth0.name || 'Stranger'
    },
    user () {
      return this.$store.state.user.auth0
    },
    userToken () {
      if (this.$store.state.user && this.$store.state.user.token) {
        return this.$store.state.user.token.accessToken
      } else {
        return null
      }
    },
    loggedIn () {
      return this.userToken
    },
    authorized () {
      const namespace = process.env.VUE_APP_NAMESPACE
      if (this.user && this.user[namespace]) {
        return this.user[namespace].sid === process.env.VUE_APP_DEFAULT_SID || this.user[namespace].super_user
      }
      return false
    }
  },

  methods: {
    logIn () {
      localStorage.setItem('redirect_to_url', this.$route.fullPath)
      this.$auth.login()
    },
    logOut () {
      localStorage.setItem('redirect_to_url', this.$route.fullPath)
      this.$auth.logout()
    },
    redirectView () {
      if (this.loggedIn) {
        var redirectTo = localStorage.getItem('redirect_to_url')
        if (redirectTo) { // ensure that no redirect happens if it's the same URL (home)
          localStorage.removeItem('redirect_to_url')
          this.$router.push(redirectTo)
        } else {
          this.$router.push('/admin')
        }
      }
    }
  },

  mounted () {
    this.$auth.silentLogin()
    this.redirectView()

    this.$eventHub.$on('set_user', (payload) => {
      this.$store.commit('AUTH0_SET_USER', { user: payload.user })
    })
    this.$eventHub.$on('save_token', (payload) => {
      this.$store.commit('SAVE_TOKEN', { accessToken: payload.accessToken, idToken: payload.idToken })
    })
    this.$eventHub.$on('log_off', (payload) => {
      this.$store.commit('LOG_OFF')
    })
  },

  watch: {
    'userToken': function (token) {
      if (token) {
        this.redirectView()
      }
    }
  }

}
</script>

<style scoped lang="scss">
.random-quotes {
  @include breakpoint($tablet) {
    max-width: 70%;
    margin: auto;
  }
}
.desktop-view {
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sensata-splash-wrapper {
  max-width: 12em;
  top: 0;
  left: 0;
  margin-top: 2em;
  margin-bottom: 2em;
  @include breakpoint($tablet) {
    max-width: 8em;
  }
  @include breakpoint($desktop) {
    max-width: 4em;
    position: fixed;
    margin-left: 1em;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  @include breakpoint($fullhd) {
    max-width: 6em;
  }
  &:hover {
    cursor: pointer;
  }
}

.log-out-button {
  bottom: 2em;
  left: 2em;
  margin-top: 1em;

  @include breakpoint($desktop) {
    position: fixed;
    margin-top: 0;
  }
}

</style>
